import React, { useState } from 'react';
import { getEnumTranslation, getUITranslation } from './utils';
import { CUISINE_TYPES, RECIPE_TYPES, CHEFS } from './translations';

const RecipeFilters = ({ filters, setFilters, lang }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleFilterChange = (filterType, value) => {
        setFilters(prev => ({
            ...prev,
            [filterType]: prev[filterType] === value ? null : value
        }));
    };

    const clearAllFilters = () => {
        setFilters({
            cuisine: null,
            type: null,
            author: null
        });
    };

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    const hasActiveFilters = Object.values(filters).some(filter => filter !== null);

    return (
        <div className="recipe-filters">
            <div className="filter-header" onClick={toggleExpanded}>
                <div className="filter-title-section">
                    <h4>{getUITranslation('filters', lang)}</h4>
                    {hasActiveFilters && (
                        <span className="active-filters-count">
                            ({Object.values(filters).filter(filter => filter !== null).length})
                        </span>
                    )}
                </div>
                <div className="filter-controls">
                    {hasActiveFilters && (
                        <button 
                            className="clear-filters-btn" 
                            onClick={(e) => {
                                e.stopPropagation();
                                clearAllFilters();
                            }}
                        >
                            {getUITranslation('clearAll', lang)}
                        </button>
                    )}
                    <button className="expand-toggle-btn">
                        <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
                            ▼
                        </span>
                    </button>
                </div>
            </div>
            
            <div className={`filter-sections ${isExpanded ? 'expanded' : 'collapsed'}`}>
                {/* Cuisine Type Filter */}
                <div className="filter-section">
                    <h5>{getUITranslation('cuisine', lang)}</h5>
                    <div className="filter-options">
                        {Object.entries(CUISINE_TYPES).map(([key, cuisineType]) => (
                            <button
                                key={key}
                                className={`filter-tag ${filters.cuisine === cuisineType ? 'active' : ''}`}
                                onClick={() => handleFilterChange('cuisine', cuisineType)}
                            >
                                {getEnumTranslation(cuisineType, lang)}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Recipe Type Filter */}
                <div className="filter-section">
                    <h5>{getUITranslation('recipeType', lang)}</h5>
                    <div className="filter-options">
                        {Object.entries(RECIPE_TYPES).map(([key, recipeType]) => (
                            <button
                                key={key}
                                className={`filter-tag ${filters.type === recipeType ? 'active' : ''}`}
                                onClick={() => handleFilterChange('type', recipeType)}
                            >
                                {getEnumTranslation(recipeType, lang)}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Author Filter */}
                <div className="filter-section">
                    <h5>{getUITranslation('author', lang)}</h5>
                    <div className="filter-options">
                        {Object.entries(CHEFS).map(([key, chef]) => (
                            <button
                                key={key}
                                className={`filter-tag ${filters.author === chef ? 'active' : ''}`}
                                onClick={() => handleFilterChange('author', chef)}
                            >
                                {getEnumTranslation(chef, lang)}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecipeFilters; 